import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlackRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#33d375",
			d: "M33 8a4 4 0 0 0-8 0v11a4 4 0 0 0 8 0zm10 11a4 4 0 0 1-4 4h-4v-4a4 4 0 0 1 8 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#40c4ff",
			d: "M8 14a4 4 0 0 0 0 8h11a4 4 0 0 0 0-8zM19 4a4 4 0 0 1 4 4v4h-4a4 4 0 0 1 0-8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#e91e63",
			d: "M14 39a4 4 0 0 0 8 0V28a4 4 0 0 0-8 0zM4 28a4 4 0 0 1 4-4h4v4a4 4 0 0 1-8 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffc107",
			d: "M39 33a4 4 0 0 0 0-8H28a4 4 0 0 0 0 8zM28 43a4 4 0 0 1-4-4v-4h4a4 4 0 0 1 0 8"
		})
	]
});
export default SvgSlackRegularIcon;
